/**
 * Created by Ning Jiang on 11/17/2016.
 */
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";


import ("pixi.js");
declare global {
    interface Window {
        PIXI: any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require ("pixi-spine");
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";

import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

import {DevInfoPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/DevInfoPlugin";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {ImmortalFruits} from "./game/ImmortalFruits";
import {IGambleConfig, NoLimitGamblePlugin} from "@nolimitcity/slot-gamble/bin/NoLimitGamblePlugin";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {ImmortalFruitConfig} from "./game/intro/ImmortalFruitConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
// gamble config to be provided to the gamble plugin, all of these properties are optional, it will use default if not provided.
const gambleConfig: IGambleConfig = {
    useDefaultAssets: false,
    winLoseTextStyle: new PIXI.TextStyle({
        dropShadow: true,
        dropShadowAlpha: 1.0,
        dropShadowAngle: -1.57,
        dropShadowBlur: 40,
        dropShadowColor: "#ffffff",
        dropShadowDistance: 0,
        fill: [
            "#6f0000",
            "red"
        ],
        fontSize: 100,
        lineJoin: "round",
        strokeThickness: 5,
        padding: 40,
        fontFamily: OpenSans.FAMILY,
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.EXTRA_BOLD
    }),
    pieColor: 0xff0000,
    positionOffset: {
        portrait: {
            x: 0,
            y: -70
        },
        landscape: {
            x: 0,
            y: 0
        }
    }
}

window.NolimitLauncher = NolimitLauncher.instance;
import {ImmortalFruitsPromoPanelConfig} from "./game/ImmortalFruitsPromoPanelConfig";
NolimitLauncher.instance.launch([
    new ImmortalFruits(),
    new SlotKeypad(),
    new NolimitPromotionPlugin(new ImmortalFruitsPromoPanelConfig()),
    new NoLimitGamblePlugin(gambleConfig),
    new NolimitGameIntroPlugin(new ImmortalFruitConfig()),
    new NolimitSlotAudio()
]);
// const useDefaultAssetsInGamble: boolean = false;
// NolimitLauncher.instance.launch([new ImmortalFruits(), new SlotKeypad(),  new NolimitSlotAudio(),new DevInfoPlugin(),  new NolimitPromotionPlugin(), new NoLimitGamblePlugin(useDefaultAssetsInGamble),new  NolimitGameIntroPlugin(new ImmortalFruitConfig())]);
